import axios from "axios";
import { BACKEND_URL } from "../utils/envConfig";

// Adjust the URL to match your backend route that sends SMS messages
const SMS_API_URL = `${BACKEND_URL}/notifications/sms/portal-credentials`;

/**
 * Sends patient portal login credentials to the given mobile number via SMS.
 *
 * NOTE: This assumes your backend exposes an endpoint at SMS_API_URL
 * which accepts { mobile, username, password } and handles the actual SMS sending.
 */
export const sendPortalCredentialsSms = async ({ mobile, username, password }) => {
  if (!mobile || !username || !password) return;

  try {
    await axios.post(SMS_API_URL, {
      mobile,
      username,
      password,
    });
  } catch (error) {
    console.error("Failed to send portal credentials SMS:", error?.message || error);
    // Intentionally do not throw, so existing flows are not broken
  }
};


